import * as styles from "./CommandItem.css";

import { Icon } from "@frontend/components/atoms/Icon";
import { useLingui } from "@lingui/react";

import type { Command } from "../commands/types";

export type CommandItemProps = {
  command: Command;
};

export function CommandItem({ command }: CommandItemProps) {
  const { _ } = useLingui();

  return (
    <div className={styles.row}>
      <span className={styles.iconBadge}>
        <Icon name={command.icon} size="sm" />
      </span>

      <span className={styles.title}>{_(command.label)}</span>
    </div>
  );
}
